document.addEventListener('DOMContentLoaded', function () {
  const blocks = document.querySelectorAll('[data-read-more]');

  blocks.forEach(function (block) {
    const inner = block.querySelector('[data-read-more-inner]');
    const content = block.querySelector('[data-read-more-content]');
    const toggle = block.querySelector('[data-read-more-toggle]');
    const toggleText = toggle ? toggle.querySelector('.product-description-read-more__text') : null;

    if (!inner || !content || !toggle || !toggleText) return;

    function getLineHeight() {
      const styles = window.getComputedStyle(content);
      let lineHeight = parseFloat(styles.lineHeight);

      if (isNaN(lineHeight)) {
        const fontSize = parseFloat(styles.fontSize);
        lineHeight = fontSize * 1.2;
      }

      return lineHeight;
    }

    function updateReadMore() {
      const lineHeight = getLineHeight();

      const collapsedLines = 18;
      const minimumExtraLines = 4;

      const collapsedHeight = lineHeight * collapsedLines;
      const minimumExtraHeight = lineHeight * minimumExtraLines;
      const fullHeight = content.scrollHeight;

      if (fullHeight <= collapsedHeight + minimumExtraHeight) {
        toggle.style.display = 'none';
        inner.style.maxHeight = 'none';
        block.classList.remove('needs-read-more', 'expanded');
        toggleText.textContent = 'Read more';
        return;
      }

      toggle.style.display = '';
      block.classList.add('needs-read-more');

      if (block.classList.contains('expanded')) {
        inner.style.maxHeight = fullHeight + 'px';
      } else {
        inner.style.maxHeight = collapsedHeight + 'px';
      }
    }

    updateReadMore();

    toggle.addEventListener('click', function () {
      const lineHeight = getLineHeight();
      const collapsedHeight = lineHeight * 18;
      const isExpanded = block.classList.contains('expanded');

      if (isExpanded) {
        inner.style.maxHeight = collapsedHeight + 'px';
        block.classList.remove('expanded');
        toggleText.textContent = 'Read more';
      } else {
        inner.style.maxHeight = content.scrollHeight + 'px';
        block.classList.add('expanded');
        toggleText.textContent = 'Read less';
      }
    });

    window.addEventListener('resize', updateReadMore);
  });
});